import { createContext } from "react";

interface DateTimeRangeTimePickerContextValue {
	readonly open: boolean;
	readonly setOpen: (open: boolean) => void;
}

export const DateTimeRangeTimePickerContext = createContext<DateTimeRangeTimePickerContextValue>({
	open: false,
	setOpen: () => undefined,
});
